import { createContext, useContext } from "react"
import { ReferentialAction, ReferentialAsyncActions, ReferentialSyncActions } from "./actions"
import { ReferentialState } from "./types"

const contextErrorMessage = 'useReferential must be used within a ReferentialProvider'

export interface ReferentialContextProps extends ReferentialAsyncActions, ReferentialSyncActions {
  state: ReferentialState
  dispatch: React.Dispatch<ReferentialAction>
}

export const ReferentialContext = createContext<ReferentialContextProps | undefined>(undefined)

export const useReferential = () => {
  const context = useContext(ReferentialContext)
  if (context === undefined) {
    throw new Error(contextErrorMessage)
  }
  return context
}

export const useReferentialActions = () => {
  const context = useContext(ReferentialContext)
  if (context === undefined) {
    throw new Error(contextErrorMessage)
  }

  const {
    state,
    dispatch,
    ...actions
  } = context

  return actions
}

export const useReferentialState = () => {
  const context = useContext(ReferentialContext)
  if (context === undefined) {
    throw new Error(contextErrorMessage)
  }

  return context.state
}
